module.exports = __webpack_public_path__ + "img/1505549175.7577a02f.jpg";